import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteContext = createContext({ social: {}, seo: {}, pageSeo: null, setPageSeo: () => {} });

export function SiteProvider({ children }) {
  const [site, setSite] = useState({ social: {}, seo: {} });
  const [pageSeo, setPageSeo] = useState(null); // per-route override, set by CmsPage
  useEffect(() => {
    api.get("/site").then(({ data }) => setSite(data)).catch(() => {});
  }, []);
  return <SiteContext.Provider value={{ ...site, pageSeo, setPageSeo }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
